import { useRef, useState } from "react";
import { Container, Nav, Navbar, Col, Row } from "react-bootstrap";

import CounterItems from "./counterItems";
import MenuItems from "./menuItems";

import geopolyLogo from "../../assets/geopoly_logo.png";

import "./headerStyles.css";

const Header = ({
  geoTokensAmount,
  NFTsAmount,
  geoSpinsAmount,
  setDisplayBuyGEOTokens,
  setDisplayDownloads,
  onClickConnectWallet,
}) => {
  const [show, setShow] = useState(false);
  const menuDesktop = useRef(null);

  const menuButtonClick = () => {
    setShow(!show);
  };

  return (
    <div className="relative">
      <Navbar
        collapseOnSelect
        fixed="top"
        expand=""
        className="header-navbar navbar-dark"
      >
        <Container className="header-container">
          <Navbar.Brand href="/" className="header-brand">
            <img src={geopolyLogo} alt="Geopoly" />
          </Navbar.Brand>
          <Row className="d-flex">
            <Col className="d-none d-lg-block pr-0">
              <CounterItems
                geoTokensAmount={geoTokensAmount}
                NFTsAmount={NFTsAmount}
                geoSpinsAmount={geoSpinsAmount}
                setDisplayBuyGEOTokens={setDisplayBuyGEOTokens}
                onClickConnectWallet={onClickConnectWallet}
              />
            </Col>
            <Col xs={1} className="toggle-button-col">
              <Navbar.Toggle
                className="toggle-button"
                onClick={menuButtonClick}
              />
            </Col>
          </Row>
          <Navbar.Collapse className="d-lg-none header-menu justify-content-end">
            <Nav className="my-nav align-items-center">
              <MenuItems
                isMobile={true}
                setDisplayBuyGEOTokens={setDisplayBuyGEOTokens}
                setDisplayDownloads={setDisplayDownloads}
              />
            </Nav>
            <CounterItems
              geoTokensAmount={geoTokensAmount}
              NFTsAmount={NFTsAmount}
              geoSpinsAmount={geoSpinsAmount}
              setDisplayBuyGEOTokens={setDisplayBuyGEOTokens}
              onClickConnectWallet={onClickConnectWallet}
            />
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <div className="d-none d-lg-block menu-desktop" ref={menuDesktop}>
        <div className={show ? "show" : "hide"}>
          <MenuItems
            isMobile={false}
            setDisplayBuyGEOTokens={setDisplayBuyGEOTokens}
            setDisplayDownloads={setDisplayDownloads}
          />
        </div>
      </div>
    </div>
  );
};

export default Header;
